export default function menu() {
    if(document.querySelector(".sidebar-mobile")) {
        let menu = document.querySelector(".menu-button");
        let mainMenu = document.querySelector(".main-menu");

        menu.addEventListener("click", () => {
            menu.classList.toggle("is-active");
            mainMenu.classList.toggle("is-active");
        });
    }
}
